import createClient, { type Middleware } from 'openapi-fetch';
import type { paths } from './types.gen';

export type ApiClient = ReturnType<typeof createClient<paths>>;

export type CreateApiClientOptions = {
  baseUrl: string;
  /**
   * Returns the current Cognito ID token (or `undefined` if the user is not
   * signed in). Called on every request. Callers typically wrap this around
   * `useAuth().user?.id_token` from react-oidc-context.
   */
  getAccessToken?: () => string | undefined | Promise<string | undefined>;
};

export function createApiClient({ baseUrl, getAccessToken }: CreateApiClientOptions): ApiClient {
  const client = createClient<paths>({ baseUrl });
  if (getAccessToken) {
    const authMiddleware: Middleware = {
      async onRequest({ request }) {
        const token = await getAccessToken();
        if (token) {
          request.headers.set('Authorization', `Bearer ${token}`);
        }
        return request;
      },
    };
    client.use(authMiddleware);
  }
  return client;
}
